import React from 'react';
import loadingImg from '@assets/loading.svg';

import styles from './styles.scss';

function Loader({ message }) {
  return (
    <div className="alignCenter">
      <img src={loadingImg} alt="Loading" className={styles.loading} />
      {message && (<p className="fs16 alignCenter textMainBlue bold">{message}</p>)}
    </div>
  );
}

export default Loader;
